import * as services from './platformAccounts.queries';

export default services;
